import axios from "@/lib/axios";

const getCancel = (custCode: string | undefined) => {
  return axios.get(`/facility/flat_rates/terminate_cancels/${custCode}/cancel`);
}

export default getCancel;